import React from 'react';
import styled from 'styled-components';

import SegmentUpdateName from '../../../containers/segment/update/Name';
import SegmentUpdateDateRangePicker from '../../../containers/segment/update/DateRangePicker';

const StyledSegmentUpdateHeader = styled.div`
  background-color: rgb(247, 246, 244);
  padding: 15px;
`;

const SegmentUpdateHeader = ({ showNotValidFields }) => (
  <StyledSegmentUpdateHeader>
    <SegmentUpdateName showNotValidFields={showNotValidFields} />
    <SegmentUpdateDateRangePicker />
  </StyledSegmentUpdateHeader>
);

export default SegmentUpdateHeader;
